import { Components } from '@mui/material';

export const MuiCheckbox: Components['MuiCheckbox'] = {
  defaultProps: {
    color: 'primary',
  },
};
